import type { App } from 'vue';
import { OverlayManager } from './OverlayManager';

export const overlayManager = new OverlayManager();

export default {
  install(app: App) {
    app.provide('overlay', overlayManager);
  }
};
